
<!-- 
  Date Picker Component
  ---------------------
  This component provides a date picker interface for selecting dates. It emits events for date selection, cancellation,
  and confirmation. The selected date is formatted to ISO string format.

  Features:
  - Displays a date picker for selecting dates.
  - Emits events for date selection, cancellation, and confirmation.
  - Formats the selected date to ISO string format.
-->

<!--Ionic Date Picker -->
  <ion-datetime
    [(ngModel)]="formattedStartDate"
    (ngModelChange)="onDateSelected($event)"
    presentation="date"
  ></ion-datetime>

<!-- Footer with Cancel and Select Date buttons -->
<ion-footer>
  <ion-toolbar>
     <!-- Cancel Button -->
    <ion-buttons slot="start">
      <ion-button (click)="onCancelDatePicker()">
        <ion-text color="danger">
          <ion-icon name="close-circle"></ion-icon>
        &nbsp;Cancel
      </ion-text>
      </ion-button>
    </ion-buttons>
        <!-- Select Date Button -->
    <ion-buttons slot="end">
      <ion-button (click)="onConfirmSelectedDate()">
        <ion-text color="success">
          <ion-icon name="checkmark"></ion-icon>
        &nbsp;Select Date
      </ion-text>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

